/* eslint-disable */
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import validator from 'validator';
import { Post } from '../../Axios/AxiosFunctions';
import Button from '../../Component/Button/Button';
import CustomPhoneInput from '../../Component/CustomPhoneInput';
import Input from '../../Component/Input/Input';
import { Radio } from '../../Component/Radio/Radio';
import ModalSkeleton from '../ModalSkeleton';
import classes from './CompanyOrAgentEmailModal.module.css';

import { MdLocationPin } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Captcha from '../../Component/Captcha';
import Checkbox from '../../Component/Checkbox/Checkbox';
import TextArea from '../../Component/TextArea';
import { BaseURL, apiHeader, imageUrl } from '../../config/apiUrl';

const CompanyOrAgentEmailModal = ({ show, setShow, type = 'agent', data, t }) => {
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { accessToken } = useSelector((state) => state.authReducer);
  const [reason, setReason] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [contactMethod, setContactMethod] = useState('Email');
  const [isLoading, setIsLoading] = useState(false);
  const [isCaptcha, setIsCaptcha] = useState(false);
  const [isAccept, setIsAccept] = useState(false);

  const [isSuccess, setIsSuccess] = useState(false);
  const handleSend = async () => {
    const url = BaseURL('inquiry/create');
    const params = {
      message: reason,
      email,
      name,
      phone,
      preferredContactMethod: contactMethod,
      inquiryType: 'message',
      inquiryTo: data?._id
    };

    for (let key in params) {
      if (!params[key]) {
        return toast.error(t('modal.error', { key: key }));
      }
    }

    if (!validator.isEmail(email)) {
      return toast.error(t('modal.emailNotValid'));
    }

    if (!isCaptcha || !isAccept) return toast.error(t('modal.acceptTerms'));

    setIsLoading(true);
    const response = await Post(url, params, apiHeader(accessToken));
    if (response !== undefined) {
      toast.success(t('modal.success'));
      setShow(false);
    }
    setIsLoading(false);
  };

  return (
    <>
      {show && (
        <ModalSkeleton
          width={'670px'}
          show={show}
          setShow={setShow}
          header={'Email Agent'}
          headerClass={classes.header}
          modalClass={classes.body}>
          <style>{`.DropdownOptionContainer{
          text-transform:none;
        }
        
       
        `}</style>
          <Row className={classes.gap}>
            <Col md={12}>
              <Row className={[classes.propertyCard, 'gx-0'].join(' ')}>
                <Col md={5}>
                  <div className={classes.imgDiv}>
                    <img src={imageUrl(data?.photo)} />
                  </div>
                </Col>
                <Col md={7} className={classes.detailInfo}>
                  {type == 'agent' ? (
                    <>
                      <h5>{data?.agentName?.[selectedLanguage]}</h5>
                      <p>{data?.agentDesignation?.[0]?.[selectedLanguage]}</p>
                    </>
                  ) : (
                    <>
                      <h6>{data?.companyName?.[selectedLanguage]}</h6>
                      <h5>{data?.companyType?.[selectedLanguage]}</h5>
                      <div className={classes?.location}>
                        <MdLocationPin fill="var(--secondary-clr)" size={22} />
                        <span>{data?.address}</span>
                      </div>
                    </>
                  )}
                </Col>
              </Row>
            </Col>
            <Col md={12} className={classes.TextAreaDiv}>
              <TextArea value={reason} setValue={setReason} placeholder={t('modal.placeholder')} />
            </Col>
            <Col md={12} className={classes.TextAreaDiv}>
              <Input
                inputStyle={{
                  borderRadius: '5px'
                }}
                value={name}
                setValue={setName}
                placeholder={t('modal.name')}
              />
            </Col>
            <Col md={6} className={classes.TextAreaDiv}>
              <Input
                value={email}
                setValue={setEmail}
                inputStyle={{
                  borderRadius: '5px'
                }}
                placeholder={t('modal.email')}
              />
            </Col>

            <Col md={6} className={classes.phoneDiv}>
              <CustomPhoneInput value={phone} setter={setPhone} placeholder={t('modal.phone')} />
            </Col>
            <Col md={12} className={classes.contactWrap}>
              <p>{t('modal.contactMethod')}</p>
              <div className={classes.methodWrap}>
                <Radio
                  value={contactMethod}
                  setValue={setContactMethod}
                  label={t('modal.contactMethodEmail')}
                />
                <Radio
                  value={contactMethod}
                  setValue={setContactMethod}
                  label={t('modal.contactMethodPhone')}
                />
                <Radio
                  value={contactMethod}
                  setValue={setContactMethod}
                  label={t('modal.whatsapp')}
                />
              </div>
            </Col>

            <Col md={12}>
              <Captcha setValue={setIsCaptcha} />
            </Col>
            <Col md={12}>
              <Checkbox
                label={t('modal.termsAndConditions')}
                value={isAccept}
                setValue={setIsAccept}
              />
            </Col>
            <Col md={12}>
              <Button
                className={classes.btn}
                onClick={handleSend}
                label={isLoading ? t('modal.sending') : t('modal.send')}
              />
            </Col>
          </Row>
        </ModalSkeleton>
      )}
      {/* {isSuccess && (
        <SuccessModal
          t={t}
          title={t('successModal.success')}
          show={isSuccess}
          setShow={setIsSuccess}
        />
      )} */}
    </>
  );
};

export default CompanyOrAgentEmailModal;

const companyLogo =
  'https://www.makeitealing.co.uk/sites/default/files/upload/logos/barnard_marcus_3f09fb979cb9238cb5ffc63a6d28aed6.png';
